module.exports = __webpack_public_path__ + "static/media/compliance.3c98cff8.png";